<template>
  <div class="page">
    <div class="head">
        进度管理
    </div>
    <div class="content">
        <div class="bar">
            <span class="bartip">学号:</span>
            <el-input style="width:10%" clearable v-model="query.keyword" placeholder="请输入学号或姓名">
                
            </el-input>
            <span class="bartip">站点:</span>
            <el-select style="width:12%" v-model="query.siteId" clearable placeholder="请选择" @change="changeSite">
                <el-option
                v-for="item in sites"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>

            <span class="bartip">单位:</span>
            <el-select style="width:12%" v-model="query.unitId" clearable filterable placeholder="请选择">
                <el-option
                v-for="item in units"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>

         <!--    <span class="bartip">层次:</span>
           <el-select style="width:8%" v-model="query.levelId" clearable placeholder="请选择">
                <el-option
                v-for="item in levels"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select> -->
         <!--    <span class="bartip">专业:</span>
            <el-select style="width:8%" v-model="query.majorId" clearable placeholder="请选择">
                <el-option
                v-for="item in majors"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select> -->
            <span class="bartip">实验批次:</span>
            <el-select style="width:8%" v-model="query.expBatchId" clearable placeholder="请选择">
                <el-option
                v-for="item in expbatches"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
            <span class="bartip">状态:</span>
            <el-select style="width:8%" v-model="query.reportStatus" clearable placeholder="请选择">
                <el-option
                v-for="item in status"
                :key="item.id"
                :label="item.name"
                :value="item.id">
                </el-option>
            </el-select>
             <span class="bartip">进度:</span>
            <el-select style="width:8%" v-model="query.begin" clearable placeholder="请选择">
                <el-option
                v-for="item in starts"
                :key="item"
                :label="item"
                :value="item">
                </el-option>
            </el-select>

            <span class="bartip" >到</span>
            <el-select style="width:8%" v-model="query.end" clearable placeholder="请选择">
                <el-option
                v-for="item in ends"
                :key="item"
                :label="item"
                :value="item">
                </el-option>
            </el-select>

            <el-button  class="bartip"  @click="toSearch()" size="small" type="primary" round>搜索</el-button>
             <el-button  class="bartip"  @click="download()" size="small" type="primary" >批量下载</el-button>
<!-- 
            <el-button  class="bartip"  @click="tobatchNotice()" size="small" type="primary">批量通知</el-button> -->
        </div>
        <div class="table" >
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                type="index"
                label="序号"
                width="60"
                :index="indexMethod"
                align="center"
                />
                <el-table-column
                    prop="code"
                    label="学号">
                </el-table-column>
                <el-table-column
                    prop="displayName"
                    label="姓名">
                </el-table-column>
                <el-table-column
                    prop="number"
                    label="进度(%)">
                </el-table-column>
                <el-table-column
                    prop="reportStatus"
                    label="状态">
                </el-table-column>
                <el-table-column
                    prop="expBatch"
                    label="实验批次">
                </el-table-column>
                <el-table-column
                    prop="course"
                    label="案例名称" show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                    prop="major"
                    label="专业">
                </el-table-column>
                <el-table-column
                    prop="site"
                    label="站点" show-overflow-tooltip>
                </el-table-column>
                 <el-table-column
                    prop="unit"
                    label="单位" show-overflow-tooltip>
                </el-table-column>
               <!--  <el-table-column label="操作">
                    <template #default="record">
                        <el-link :underline="false" @click.prevent="toNotice(record.row)" type="primary">通知</el-link>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>
        <!-- 分页 -->
            <el-pagination
            @current-change="handleCurrentChange"
            :current-page="query.currentPage"
            :page-size="query.size"
            layout="total, prev, pager, next, jumper"
            :total="query.total"
            />
        
        
    </div>
  </div>
</template>

<script>
import ajaxObj from "@/ajax";
export default {
    inject: ['reload'],
 data(){
     return {
        searchInput:'',
        tableData:[],

        query: {
            currentPage: 1,
            size: 10,
            page:0,
            total: 0,
            keyword:'',
            siteId:'',
            expBatchId:'',
            enrollBatchId:'',
            levelId:'',
            majorId:'',
            unitId:"",
            number:'',
            begin:'',
            end:'',
            reportStatus:''
        },
        // 添加 表单
        visible:false,
        visible2:false,
        title:'添加进度信息',
        title2:'修改进度信息',
        rules: {
            
        },
        // 搜索
        sites:[],
        levels:[],
        majors:[],
        expbatches:[],
        enrollbatches:[],
        numbers:[10,20,30,40,50,60,70,80,90,100],
        starts:[0,10,20,30,40,50,60,70,80,90,99,100],
        ends:[0,10,20,30,40,50,60,70,80,90,100],
        units:[],
      
        status:[
            {
              id: "UN_SUBMIT",
              name: "未提交"
            },
             {
              id: "SUBMIT",
              name: "已提交"
            },
             {
              id: "UN_MODIFY",
              name: "待修改"
            },

              {
              id: "MODIFY",
              name: "已修改"
            },



        ]

    }
 },
 methods:{
     findUserlist(){
        ajaxObj({url: "users/progress",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            //console.log(this.tableData);
            this.query.total = response.data.meta.total;
        })
     },
    changeSite(){
        this.units=[];
        // this.query.unitId = "";
        this.$set(this.query, 'unitId', '')

        ajaxObj({url: "users/units",method: "get",params:this.query})
        .then(response => {
            this.units = response.data.data;
        })


        //console.log()
        //alert(this.query.siteId == '')

    },
    //  搜索
    // 1. site查询
    findSites(){
        ajaxObj({url: "users/all-site",method: "get"})
            .then(response => {
                this.sites = response.data.data;
            })
    },
    // 2. level查询
    findLevels(){
        ajaxObj({url: "users/all-level",method: "get"})
            .then(response => {
                this.levels = response.data.data;
            })
    },
    // 3. major查询
    findMajors(){
        ajaxObj({url: "users/all-major",method: "get"})
            .then(response => {
                this.majors = response.data.data;
            })
    },
    // 4. expbatch查询
    findExpbatches(){
        ajaxObj({url: "users/all-expbatch",method: "get"})
            .then(response => {
                this.expbatches = response.data.data;
            })
    },
    // 5. enrollbatch查询
    findEnrollbatches(){
        ajaxObj({url: "users/all-enrollbatch",method: "get"})
            .then(response => {
                this.enrollbatches = response.data.data;
            })
    }, 
    toSearch(){
        this.query.currentPage = 1;
        this.query.page = this.query.currentPage -1;
        ajaxObj({url: "users/progress",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
     },

     download(){

        this.query.currentPage = 1;
        this.query.page = this.query.currentPage -1;

        let accessToken = window.localStorage.getItem('access_token');
        let url =  process.env.URL ;
        window.location.href= url+"api/progress/download?accesstoken="+accessToken
          +"&keyword="+this.query.keyword
          +"&siteId="+this.query.siteId
          +"&expBatchId="+this.query.expBatchId
          +"&levelId="+this.query.levelId
          +"&majorId="+this.query.majorId
           +"&unitId="+this.query.unitId
           +"&begin="+this.query.begin
              +"&end="+this.query.end
              +"&reportStatus="+this.query.reportStatus;

      

        // ajaxObj({url: "progress/download",method: "get",params:this.query})
        // .then(response => {
        //     // this.tableData = response.data.data;
        //     // this.query.total = response.data.meta.total;
        //})

     },
    //  通知
    toNotice(row){
        ajaxObj({url: "users/inform",method: "POST",
        data:{expBatch:row.expBatch,code:row.code}})
        .then(response => {
            console.log(response);
            this.$message({ type: 'success', message: '通知成功'});
        })
    },
    //  批量通知
    tobatchNotice(){
        if(this.query.siteId == '' && 
           this.query.expBatchId == '' &&
           this.query.enrollBatchId == '' &&
           this.query.levelId == '' &&
           this.query.majorId == '' ){
                this.$message({ type: 'warning', message: '至少选择一个筛选条件'});
        } else {
            ajaxObj({url: "users/inform",method: "POST",
            data:this.query})
            .then(response => {
                console.log(response);
                this.$message({ type: 'success', message: '通知成功'});
            })

        }
    },
    // 序号
    indexMethod(index){
       index = index + 1 + (this.query.currentPage - 1) * this.query.size;
      return index;

    },

    
    // 添加进度  表单
    dialogCloseHandler() {
        this.$refs.userForm.clearValidate()
    },
    
    toAddHandler() {
      this.form = {}
      this.setTitle('添加进度信息')
      this.showModal()
    },
    setTitle(title) {
      this.title = title
    },
    closeModal() {
      this.visible = false
    },
    showModal() {
      this.visible = true
    },
    submitHandler(){
            // 表单验证
        // this.$refs.userForm.validate((valid) => {
        //     if (valid) {
        //     // 2 提交表单
        //         ajaxObj({url: "users/add-teacher",method: "post",
        //             data:this.form
        //         })
        //         .then((response) => {
        //             this.$message({ type: 'success', message: '添加成功' });
        //             this.reload()                                               
        //         })
        //     } else {
        //         this.$message({ type: 'error', message: '添加失败' })
        //     }
        // })
    },
    // 修改进度  表单
    dialogCloseHandler2() {
        this.$refs.userForm2.clearValidate()
    },
    setTitle2(title2) {
        this.title2 = title2
    },
    closeModal2() {
      this.visible2 = false
    },
    showModal2() {
      this.visible2 = true
    },
    submitHandler2(){
            // 表单验证
        // this.$refs.userForm2.validate((valid) => {
        //     if (valid) {
        //     // 2 提交表单
        //         ajaxObj({url: "users/update",method: "post",
        //             data:this.form2
        //         })
        //         .then((response) => {
        //             this.$message({ type: 'success', message: '修改成功' });
        //             this.reload()                                               
        //         })
        //     } else {
        //         this.$message({ type: 'error', message: '修改失败' })
        //     }
        // })
    },
    //  删除进度
     deleteHandler(id){
        // if(id){
        //     ajaxObj({url: "users/delete",method: "post", data:{"id":id}})
        //     .then(response => {
        //         this.$message({ type: 'success', message: '删除成功'});
        //         this.reload()
        //     });
        // } else {
        //         this.$message({ type: 'error', message: '删除失败' })
        // }
        
     },
    //  修改进度
     editHandler(row){
      this.form2 = row
      this.setTitle2('修改进度信息')
      this.showModal2()
     },
    //  
     // 初始页currentPage、初始每页数据数pagesize和数据data
    handleSizeChange: function(size) {
    this.pagesize = size
    console.log(this.pagesize) // 每页下拉显示数据
    },
    handleCurrentChange: function(page) {
    this.query.currentPage = page;
    this.query.page = page-1;
    this.currentPage = page
    console.log(this.currentPage) // 点击第几页
        ajaxObj({url: "users/progress",method: "get",params:this.query})
        .then(response => {
            this.tableData = response.data.data;
            this.query.total = response.data.meta.total;
        })
    },

 },
 created(){
    this.findUserlist();
    this.findSites();
    this.findLevels();
    this.findMajors();
    this.findExpbatches();
    this.findEnrollbatches();
 }
}
</script>

<style scoped>
.page {
    width: 100%;
    height: 100%;
}
.head {
    padding: 20px;
    font-size: 20px;
    border-bottom: 1px solid #ccc;
    box-sizing:border-box;

}
.bar {
    height: 100px;
    box-sizing:border-box;
    padding: 20px;
    font-size: 18px;
    padding-left: 60px;
    display:flex;
    align-items:center;
}
.bartip {
    margin: 0 8px 0 8px;
}
.table {
    width:98%;
    margin:0 auto;
}
.el-pagination {
    text-align: right;
    box-sizing: border-box;
    padding-right: 100px;
    padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/teach/progress.vue